import Cookies from "js-cookie"
import { html } from "lit-html"
import { parseDate } from "../utils"
import markdown from "../utils/markdown"
import { virtual, useEffect, useState } from "haunted"
import { ROLE_ICON_MAP } from "../constants"

export const ReportingComponent = virtual(({ endpoint }) => {
  const [loading, setLoading] = useState(true)
  const [reportingList, setReportingList] = useState([])
  const csrftoken = Cookies.get("csrftoken")

  const loadReporting = () => {
    fetch(endpoint, {
      method: "GET",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrftoken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setReportingList(res)
        setLoading(false)
      })
      .catch((err) => console.error(err))
  }

  useEffect(loadReporting, [])

  const ReportingRow = ({
    id,
    name,
    tags,
    start_date: startDate,
    url: assignmentUrl,
    roles,
  }) => {
    const dateDisplayOptions = {
      year: "numeric",
      month: "short",
      day: "numeric",
    }

    return html`
      <div id="reporting-${id}" class="reporting-row py-6">
        <div class="sm:flex flex-row justify-between">
          <div class="w-full sm:w-2/3 flex flex-row flex-wrap">
            ${tags.map(
              ({ color, name }) => html`
                <span
                  class="tag py-3 px-5 mb-1 bg-tag-bg-${color.toLowerCase()} text-tag-text-${color.toLowerCase()} mr-1"
                >
                  ${name}
                </span>
              `
            )}
          </div>
          <div class="mt-5 sm:mt-0">
            ${startDate
              ? parseDate(startDate).toLocaleString("en-US", dateDisplayOptions)
              : ""}
          </div>
        </div>
        <div class="my-5">
          <a class="text-blue text-xl font-bold" href="${assignmentUrl}">
            ${name}
          </a>
        </div>
        <div>
          ${roles.map(({ category, doc_url: docUrl, teaser }) => {
            const teaserText = (teaser || "").replace(/[\n\r]/g, ` `)
            return html`
              <div class="mt-5 first:mt-0">
                <a
                  class="role-icon-link hover:border-none mr-2 ${category}"
                  href="${docUrl ? docUrl : assignmentUrl}"
                  target="${docUrl === null || docUrl.startsWith("/")
                    ? ""
                    : "_blank"}"
                >
                  <i
                    class=${category in ROLE_ICON_MAP
                      ? ROLE_ICON_MAP[category]
                      : "fas fa-pen-alt"}
                  >
                  </i>
                </a>
                <div class="mt-5 clamp-lines-3">
                  ${teaserText ? markdown(teaserText) : ``}
                </div>
              </div>
            `
          })}
        </div>
      </div>
    `
  }

  const content = reportingList.length
    ? reportingList.map((reporting) => ReportingRow(reporting))
    : html`<div class="mt-14 mx-auto text-gray-600 lg:text-lg">
        No reporting yet
      </div>`

  return html`
    <div
      class="mt-2 mb-10 md:mb-14 loader-container ${loading ? "loading" : ""}"
    >
      ${loading ? "" : content}
    </div>
  `
})
